//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import BScroll from 'better-scroll';
  export default {
    name: 'normalDay',
    props: {
      normalList: {
        type: Array,
        default: []
      },
      checkCount: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {}
    },
    computed: {
      lists() {
        const list = JSON.parse(JSON.stringify(this.normalList))
        list.forEach((item, index) => (item.hadCheck = index < this.checkCount))
        return list
      }
    },
    created() {
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    methods: {
      initScroll() {
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.tab, {
              startX: 0,
              click: true,
              scrollX: true,
              scrollY: false,
              eventPassthrough: 'vertical',
              bounce: false
            });
          } else {
            this.scroll.refresh()
          }
        })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/normalDay.vue